<template>
  <div class="index" ref="index">
    <!-- 固定回到顶部 -->
    <div class="scrollBar">
      <ul class="scrollBox">
        <li>
          <a class="goTop"   @click="goTop" v-if="showUp" :class="hoverOut?'hovercss':''" @mouseout="changeMove"></a>
        </li>
        <li>
          <div v-if="navsObj.site.site_wx_image">
            <a class="wxicon" :class="hoverOut?'hovercss':''" @mouseout="changeMove"></a>
            <div class="codebox tcodebox">
              <img :src="navsObj.site.site_wx_image" alt="">
            </div>
          </div>
        </li>
        <li>
          <a v-if="navsObj.site.app_link" class="appicon" :href="navsObj.site.app_link" target="_blank" :class="hoverOut?'hovercss':''" @mouseout="changeMove"></a>
        </li>
      </ul>
    </div>
    <!-- <a href="JavaScript:;" class="goTop">回到顶部</a> -->
    <!-- <Header :isdb="isdb"></Header> -->
    <div v-if="navsObj.site.id==1">
      <Top v-if="istrue" :wximg="navsObj.site.site_wx_image" :myuserInfo="userInfo" :navsObj="navsObj"  :loginUrls="loginUrls"/>
    </div>
    <div v-else>
      <Top :wximg="navsObj.site.site_wx_image" :navsObj="navsObj"  :loginUrls="loginUrls" v-if="hasDraw"/>
    </div>
    <Topnav :ishome="1" :applink="navsObj.site.app_link">
      <div slot="logo">
        <div class="left fl">
          <img  v-if="navsObj.site.site_logo" :src="navsObj.site.site_logo" alt="">
        </div>
      </div>
      <div slot="top" class="searchBox fl">
        <el-input placeholder="请输入内容" @change="intoSearch" v-model.trim="keyword" class="input-with-select">
            <el-select v-model="select" @change="changeSele"  slot="prepend" placeholder="请选择">
                <el-option v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item">
                </el-option>
            </el-select>
            <el-button slot="append" @click="intoSearch" icon="el-icon-search" v-preventReClick></el-button>
        </el-input>
      </div>
      <div slot="nav">
        <ul class="tnavs">
          <li class="fl" :key="i" @click="jump(i,item)" :class="i==aIndex ?'active':''" v-for="(item,i) in navsObj.channels">
            <router-link v-if="i==0 || i==1" :to="item.url">{{item.title}}</router-link>
            <a v-else  :class="item.new?'newicon':''" target="_blank">{{item.title}}</a>
          </li>
        </ul>
      </div>
      <div slot="right"></div>
    </Topnav>
    <!-- 首页菜单 -->
    <div class="inner">
      <div class="menuBox" v-if="navsObj.top_menus.length!=0">
        <a class="nav" :class="tagIndex==i?'active':''" :key="i" v-for="(item,i) in navsObj.top_menus" @click="intoTags(i,item.fid)">{{item.title}}</a>
      </div>
      <!-- 广告位 -->
      <div class="advBox" v-if="navsObj.pc_index_top_ads.length!=0">
        <a :href="getNewUrl(item.url)" :key="i" v-for="(item,i) in navsObj.pc_index_top_ads" target="_blank" class="advSrc">
          <img class="pic" :src="item.pic_url" alt="">
        </a>
      </div>
    </div>
    <!-- 内容 -->
    <div class="container inner clearfix">
      <div class="tleft"   id="menuFlag" >
        <div :class="whether ? 'isFixed' : ''">
          <!-- <div v-if="whether">
            <img src="../assets/imgs/db.png">
          </div> -->
          <!-- <img v-if="isdb" src="@/assets/imgs/db.png" class="logo" alt="" @click="intoIndex()">
          <img v-else src="@/assets/imgs/logo.png" class="logo" alt="" @click="intoIndex()"> -->
          <ul>
            <li v-for="(item,k) in navsObj.left_menus"  @click="jump(k,item)" :class="k==aIndex ?'active':''" :key="k">
              <router-link v-if="k==0||k==1" :to="item.url">{{item.title}}</router-link>
              <a v-else target="_blank">{{item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <router-view @crefresh="prefresh" :getNewUrl="getNewUrl" :isRefresh="isRefresh" v-if="navsObj.site.id==1&&istrue" :istrue="istrue" :loginUrls="loginUrls" :myuserInfo="userInfo" :streetId="streetId" :navsObj="navsObj"/>
        <div v-else >
          <router-view @crefresh="prefresh" :getNewUrl="getNewUrl" :isRefresh="isRefresh" :loginUrls="loginUrls" :streetId="streetId" v-if="navsObj.recommend_ids.length!=0" :navsObj="navsObj"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getWebsiteInfo} from "@/assets/js/global";
import Header from './common/header'
import Update from './update/update'
import Friends from './friends/friends'
import Topnav from './common/topNav'
import Top from './common/top'
import service from '@/api/service/service'
import {randomString} from '@/utils/utils.js'
import Cookies from 'js-cookie'
import {storageData} from "@/assets/js/storage";
import {Loading } from 'element-ui'
export default {
  components:{
    Header,
    Update,
    Friends,
    Topnav,
    Top
  },
  data () {
    return {
      tagIndex:'-1',
      isRefresh:false,
      hasDraw:false,
      showUp:false,
      keyword:'',
      hoverOut:false,
      istrue:false,
      aIndex:0,
      classNme:'update',
      site_id:'',
      isdb:false,
      streetId:'',
      msg: '',
      select:'帖子',
      selectIndex:'1',
      options: [
        {
          value: '1',
          label: '帖子'
        }, {
          value: '2',
          label: '活动'
        }
      ],
      navsObj:{
        pc_index_top_ads:[],
        top_menus:[],
        pc_index_right_ads_1:[],
        pc_index_right_ads_2:[],
        pc_index_right_ads_3:[],
        hot_threads:[],
        activitys:[],
        recommend_ids:[],
        site:{
          site_wx_image:'',
          site_logo:'',
          id:''
        }
      },
      aIndex:0,
      whether:'',
      loginUrls:{
        login_out: "",
        login_url:""
      },
      userInfo:{
        avatar: "",
        coinNum: 0,
        groupName: "",
        levelInfo: {myInfo: {currentLevel: ""}},
        threadNum: "",
        username:''
      },
    }
  },
  filters:{
  },
  computed:{
  },
  created() {
    // console.log(getWebsiteInfo())
    this.site_id = getWebsiteInfo().site_id
    document.title=getWebsiteInfo().site_name
    // let hlink = window.location.href
    // if(this.$route.query.site_id) {
    //   this.site_id = this.$route.query.site_id
    // }else{
    //   if(hlink.indexOf('bjdongba.cn')>-1) {
    //     this.streetId = '110105039000'
    //     this.isdb = true
    //     this.site_id = 2
    //   }else if(hlink.indexOf('bjchangping.cn')>-1) {
    //     this.site_id = 3
    //   }else if(hlink.indexOf('bjchaoyang.cn')>-1) {
    //     this.site_id = 4
    //   }else if(hlink.indexOf('bjtzh.top')>-1){
    //     this.site_id = 5
    //   }else if(hlink.indexOf('bjhd.top')>-1) {
    //     this.site_id = 6
    //   }else if(hlink.indexOf('bjshy.top')>-1) {
    //     this.site_id = 7
    //   }else if(hlink.indexOf('bjdaxing.cn')>-1) {
    //     this.site_id = 8
    //   }else if(hlink.indexOf('bjfengtai.cn')>-1) {
    //     this.site_id = 9
    //   }else{
    //     this.site_id = 1
    //   }
    // }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.getNavs()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods:{
    // 导航跳转
    jump(i,item) {
      if(i==0||i==1) {
        this.aIndex = i
      }else{
        let hlink = window.location.href
        const a = document.createElement("a");
        a.href = item.url;
        a.target = "_blank";
        a.click();
      }
    },
    getNewUrl(url) {
      if(url.indexOf('?')>-1) {
        if(url.indexOf('site_id')>-1) {
          return `${url}`
        }else{
          return `${url}&site_id=${this.navsObj.site.id}`
        }
      }else{
        return `${url}?site_id=${this.navsObj.site.id}`
      }
    },
    prefresh(data) {
      if(data) {
        this.getNavs()
      }
    },
    changeMove() {
      this.hoverOut = true
    },
    goTop() {
      var timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.showUp = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },30)
    },
    handleScroll () {
       //计算滚动条位置
    	 var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    	 //计算绑定div位置
    	 var offsetTop = document.querySelector('#menuFlag').offsetTop;
    	 //进行比较设置位置fixed
    	 this.whether = scrollTop > offsetTop;
      //  刷新
       this.isRefresh = scrollTop > offsetTop;
       if(scrollTop>100) {
        //  回到顶部
        this.showUp = true
       }else{
         this.showUp  = false
       }
    },
    intoTags(i,fid) {
      // this.aIndex = i
      this.tagIndex = i
      this.$router.push(`/bbs?fid=${fid}`)
    },
    // 区分登录
    isLogin() {
      let str = Date.parse(new Date())
      this.$fetchGet(`http://www.wangjing.cn/www/forum/pc_login.php?t=${str}`,{}).then((res) => {
        this.loginUrls = res.data
        localStorage.setItem('loginUrls',JSON.stringify(res.data))
        if(res.data.user) {
          this.userInfo = res.data.user
        }else{
          storageData.clearUserInfo()
        }
        this.istrue = true
      })
    },
    // 获取导航
    getNavs() {
      let reqId = ''
      if(Cookies.get('request_id')) {
        reqId = Cookies.get('request_id')
      }else{
        let str = randomString(16)
        Cookies.set('request_id',str,{
          expires: 1
        })
        reqId = str
      }
      let loadingInstance  = Loading.service({
        fullscreen: true
      })

      this.$fetchPost('/pchome',{site_id:this.site_id,request_id:reqId}).then(res => {
        if(res.code == '200') {
          let data = res.data
          if(data.local_news.length!=0) {
            data.local_news.forEach((item,i) => {
              item.no = i
            });
          }
          this.navsObj = data
          localStorage.setItem('navsObj',JSON.stringify(data))
          loadingInstance.close()
          this.hasDraw = true
          // document.title = data.site.site_title?data.site.site_title:data.site.site_name
          if(data.site.id==1) {
            this.isLogin()
          }
        }
      })
    },
    intoSearch() {
      if(!this.keyword) {
        this.$message({
          message: '请输入搜索内容',
          type: 'warning'
        });
      }else{
        let routeData = this.$router.resolve({
          path:`/search?sid=${this.navsObj.site.id}`,
          query:{
            curtab:this.selectIndex,
            keywords:this.keyword
          }
        })
        window.open(routeData.href, '_blank');
      }
    },
    changeSele(val) {
      this.selectIndex = val.value;
      this.select = val.label;
    },
    intoIndex() {
      this.$router.push({path:'/',name:'index'})
    },
    intoPage(name, path) {
      this.className = name
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/index.less';
.index{
  position: relative;
  -webkit-overflow-scrolling:touch;
  .scrollBar{
    position: fixed;
    width: 62px;
    bottom: 10px;
    left:50%;
    height: 300px;
    z-index:9;
    margin-left: 560px;
    .scrollBox{
      li{
        width:62px;
        height: 62px;
        margin:0 0 5px 0;
        border-radius:5px;
        cursor: pointer;
        &:hover{
          .codebox{
            display: block;
          }
          a{
            &.goTop{
              background-position:-62px 0px;
              transition:all 0.2s ease-in-out;
            }
            &.wxicon{
              background-position:-62px -62px;
              transition:all 0.2s ease-in-out;
            }
            &.appicon{
              background-position:-62px -124px;
              transition:all 0.2s ease-in-out;
            }
          }
        }
        .codebox{
          display: none;
          position: absolute;
          width:203px;
          left:-216px;
          background:#F6F6F6;
          border-radius:5px;
          z-index:9999999;
          padding:20px 20px 30px;
          border:1px solid #ccc;
          top:0px;
          img{
            width:163px;
          }
          &.tcodebox{
            top:-84px;
          }
          &::before{
            content:'';
            position: absolute;
            right:-14px;
            content: '';
            width:14px;
            height: 23px;
            bottom:23px;
            background: url('~@/assets/imgs/a.png') no-repeat;
          }
        }
        a{
          width:62px;
          height: 62px;
          display: inline-block;
          border-radius:5px;
          background:url('~@/assets/imgs/bgg.png') no-repeat;
          background-position: 0px 0px;
          &.hovercss{
            background-position: 0px 0px;
            transition:all 0.2s ease-in-out;
          }
          &.wxicon{
            background-position: 0px -62px;
          }
          &.appicon{
            background-position: 0px -124px;
          }
        }
      }
    }
  }
  .searchBox{
    border-color:@hred !important;
    .el-input__inner{
      height: 44px !important;
      border-right-color: @hred !important;
    }
  }
  .tnavs{
    li{
      cursor: pointer;
      a{
        position: relative;
        &.newicon{
          &::before{
            position: absolute;
            right:14px;
            top:-5px;
            width: 29px;
            height: 16px;
            content:'';
            display: inline-block;
            background: url('~@/assets/imgs/new.png') no-repeat;
            background-size:29px 16px;
          }
        }
      }
      &.active{
        background:#aa142d;
      }
    }
  }
  .menuBox{
    background:#f8f8f8;
    padding:10px 70px 30px 40px;
    .nav{
      color:@c4;
      cursor: pointer;
      font-size:@ft15;
      display: inline-block;
      width:90px;
      margin:20px 0 0 0;
      &:hover,&.active{
        color:@hred;
        font-weight: bold;
      }
    }
  }
  .advBox{
    .advSrc{
      display: block;
      width:100%;
      margin:10px 0 0;
      // height: 68px;
      .pic{
        width: 100%;
        display: block;
        // height: 68px;
      }
    }
  }
  .container{
    // padding-bottom:50px;
    margin:20px auto;
    .el-select-dropdown__item{
      text-align: center !important;
    }
    .tleft{
      .isFixed {
        width: 110px;
        background: #f8f8f8;
        text-align: center;
        position: fixed;
        top: 0;
        z-index: 1000;
      }
      width:110px;
      position: absolute;
      background:#f8f8f8;
      text-align: center;
      li{
        width:100%;
        height: 38px;
        margin:0 0 12px 0;
        line-height: 38px;
        &.active{
          background:@hred;
          a{
            color:#fff;
          }
        }
        a{
          display: inline-block;
          width:100%;
          font-size:@ft20;
          color:#323232;
          &:hover{
            color:#fff;
            background:@hred;
          }
        }
      }
      .logo{
        width:90px;
        margin:0 0 20px 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue